'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavProcesses = (_temp = _class = function (_SvgIcon) {
  _inherits(NavProcesses, _SvgIcon);

  function NavProcesses() {
    _classCallCheck(this, NavProcesses);

    return _possibleConstructorReturn(this, (NavProcesses.__proto__ || Object.getPrototypeOf(NavProcesses)).apply(this, arguments));
  }

  _createClass(NavProcesses, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M26 4c-.003-1.104-.897-1.997-2-2-.003-1.105-.9-2-2.005-2H2.005C.897 0 0 .898 0 2.005v19.99C0 23.1.895 23.997 2 24c.003 1.104.897 1.997 2 2 .003 1.105.9 2 2.005 2h19.99C27.103 28 28 27.102 28 25.995V6.005C28 4.9 27.105 4.003 26 4zM2 4.005V23c-.552-.004-1-.453-1-1.005V2.005C1 1.45 1.45 1 2.005 1h19.99c.552 0 1 .448 1.004 1H4.004C2.897 2 2 2.898 2 4.005zm2 2V25c-.55-.004-.996-.45-1-1V4.005C3 3.45 3.45 3 4.005 3H24c.55.004.996.45 1 1H6.004C4.897 4 4 4.898 4 6.005zM25.995 26L6 25.993l.004-20.118H26l-.004 17.494c0-.02.004-.04.004-.06L25.995 26z' }),
          _react2['default'].createElement('path', { d: 'M10 5h1v22.023h-1z', opacity: '.4' }),
          _react2['default'].createElement('path', { d: 'M20.52 11.5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6.52c.276 0 .5.224.5.5s-.224.5-.5.5zm-1.993 5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4.527c.277 0 .5.224.5.5s-.223.5-.5.5zm3.988 5H14c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8.515c.276 0 .5.224.5.5s-.224.5-.5.5z' }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '21',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '16',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          }),
          _react2['default'].createElement('circle', {
            cx: '10.5',
            cy: '11',
            r: '1.5',
            fillRule: 'evenodd',
            clipRule: 'evenodd'
          })
        );
      }

      return render;
    }()
  }]);

  return NavProcesses;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 28 28'
}, _temp);
exports['default'] = NavProcesses;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Nav/NavProcesses.js
// module id = 1868
// module chunks = 32